import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { About } from '../components/About';
import { Features } from '../components/Features';
import { GalleryPreview } from '../components/GalleryPreview';
import { ContactCTA } from '../components/ContactCTA';
import { Footer } from '../components/Footer';
export function HomePage() {
  return <div className="min-h-screen w-full bg-white" data-id="element-138">
      <Header data-id="element-139" />
      <main data-id="element-140">
        <Hero data-id="element-141" />
        <About data-id="element-142" />
        <Features data-id="element-143" />
        <GalleryPreview data-id="element-144" />
        <ContactCTA data-id="element-145" />
      </main>
      <Footer data-id="element-146" />
    </div>;
}